import { INotice } from '../../../interfaces';

import privateHttpClient from '../privateHttpClient';
import NoticeMapper from '../mappers/NoticeMapper';
import { urlHttpGov } from '../../urls';

class NoticeService {
    private baseURL: string = `${urlHttpGov}/panel/notice`;

    async listCityNotices(cityId: number, signal: AbortSignal): Promise<INotice[]> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/county/${cityId}`, { signal });

        return data.map((notice: any) => NoticeMapper.toDomain(notice));
    }

    async createNotice(notice: INotice) {
        const persistenceNotice = NoticeMapper.toPersistence(notice);

        const { data } = await privateHttpClient.post(this.baseURL, persistenceNotice);

        return NoticeMapper.toDomain(data);
    }

    async getNoticeById(id: number, signal: AbortSignal): Promise<INotice> {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${id}`, { signal });

        return NoticeMapper.toDomain(data);
    }

    async updateNotice(id: number, notice: any) {

        const persistenceNotice = NoticeMapper.toPersistence(notice);

        const { data } = await privateHttpClient.patch(`${this.baseURL}/${id}`, persistenceNotice);

        return NoticeMapper.toDomain(data);
    }

    async deleteNotice(id: number) {
        await privateHttpClient.delete(`${this.baseURL}/${id}`);
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new NoticeService();
